import { Dispatch, SetStateAction } from "react";
import { GetAccount200Response } from "../../../codegen-api";
import { TRANSFER_UI_ENABLED } from "../../../constants/featureFlags";
import TransferModal from "../../DepositWithdrawModal/TransferModal";
import WithdrawModal from "../../DepositWithdrawModal/WithdrawModal";
import { SubaccountsModal } from "../../Subaccounts/SubaccountsModal";
import AccountModal from "../Header/AccountModal";

interface IAccountModalsProps {
  showAccountModal: boolean;
  setShowAccountModal: Dispatch<SetStateAction<boolean>>;
  onSyncPWA?: () => void;
  openDepositFlow: () => void;
  setShowWithdrawModal: Dispatch<SetStateAction<boolean>>;
  setShowTransferModal: Dispatch<SetStateAction<boolean>>;
  subaccountsSupported: boolean;
  setShowSubaccountsModal: Dispatch<SetStateAction<boolean>>;
  setShowConnectModal: (value: boolean) => void;
  showSubaccountsModal: boolean;
  showWithdrawModal: boolean;
  accountData: GetAccount200Response | undefined;
  showTransferModal: boolean;
}

function AccountModals({
  showAccountModal,
  setShowAccountModal,
  onSyncPWA,
  openDepositFlow,
  setShowWithdrawModal,
  setShowTransferModal,
  subaccountsSupported,
  setShowSubaccountsModal,
  setShowConnectModal,
  showSubaccountsModal,
  showWithdrawModal,
  accountData,
  showTransferModal,
}: IAccountModalsProps) {
  return (
    <>
      {showAccountModal && (
        <AccountModal
          show={showAccountModal}
          onSyncPWA={onSyncPWA}
          onHide={() => setShowAccountModal(false)}
          onDepositClick={() => {
            setShowAccountModal(false);
            openDepositFlow();
          }}
          onWithdrawClick={() => setShowWithdrawModal(true)}
          onTransferClick={() => setShowTransferModal(true)}
          onSubaccountsClick={
            subaccountsSupported
              ? () => {
                  setShowAccountModal(false);
                  setShowSubaccountsModal(true);
                }
              : undefined
          }
          onContinueOnboarding={() => setShowConnectModal(true)}
        />
      )}
      {showSubaccountsModal && (
        <SubaccountsModal
          show={showSubaccountsModal}
          onHide={() => {
            setShowSubaccountsModal(false);
            setShowAccountModal(true);
          }}
        />
      )}
      {showWithdrawModal && (
        <WithdrawModal
          show={showWithdrawModal}
          accountData={accountData}
          onHide={() => {
            // Flat, like the SubaccountsModal handler above. The old form set
            // `showAccountModal` from inside an updater, which runs during the
            // render phase; the `if (prev)` guard it existed to support bought
            // nothing, since re-opening is idempotent and this block only
            // renders while `showWithdrawModal` is already true.
            setShowWithdrawModal(false);
            setShowAccountModal(true);
          }}
        />
      )}
      {/* Transfer disabled from UI/UX — flip TRANSFER_UI_ENABLED to re-enable */}
      {TRANSFER_UI_ENABLED && showTransferModal && (
        <TransferModal
          show={showTransferModal}
          accountData={accountData}
          onHide={() => {
            setShowTransferModal(false);
            setShowAccountModal(true);
          }}
        />
      )}
    </>
  );
}

export default AccountModals;
